import type { Identifiable } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { ActionClass, ToolingState } from '../../../models'
import type { CrudServiceProvider } from '../../../providers/interfaces'
import { DomainObjectUtils } from '@empathyco/playboard-core-domain'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { TOOLING_CONSTS } from '../tooling.consts'

export class ReadAction implements ActionClass {
  static async execute(
    this: void,
    { state, commit }: ActionContext<ToolingState, unknown>,
    { tool, id }: { tool: string; id: string | number },
  ): Promise<Identifiable<string | number>> {
    const service = CONTAINER.get<CrudServiceProvider>(TYPES.CrudServiceProvider)(tool)
    const item = await service.read(id)
    let { results, numFound } = state.tools[tool]?.data ?? { results: [], numFound: 0 }
    const itemIndex = results.findIndex(result => result.id === item.id)
    if (itemIndex < 0) {
      results = [...results, item]
      numFound++
    } else {
      results = [...results]
      results.splice(itemIndex, 1, item)
    }
    commit(TOOLING_CONSTS.mutations.setState, {
      [tool]: {
        data: {
          results,
          numFound,
        },
      },
    })

    return DomainObjectUtils.clone(item)
  }
}
